import { createSlice } from '@reduxjs/toolkit';
import { contentAssignmentApi } from './services/contentAssignmentService';

export const initialState = {
    // Active role for content assignment
    activeRole: {
        id: '',
        name: '',
        isAdminRole: false,
    },
    selectedDomainAndCategory: {
        domainId: '',
        categoryId: '',
        domainLabel: '',
        categoryLabel: '',
    },
    selectedContentIds: [],
    contentAssignmentSnakbar: {
        open: false,
        title: 'Success', // Default title for the snackbar
        message: '',
        severity: 'success', // 'success' | 'error' | 'info' | 'warning'
    },
};

export const contentAssignmentSliceId = 'contentAssignment';

const contentAssignmentSlice = createSlice({
    name: contentAssignmentSliceId,
    initialState,
    reducers: {
        resetContentAssignmentState: () => {
            return initialState;
        },
        setActiveRole: (state, action) => {
            state.activeRole = action.payload;
        },
        // Add your reducers here
        setSelectedDomainAndCategory: (state, action) => {
            if (!action.payload) {
                return;
            }
            state.selectedDomainAndCategory = action.payload;
        },
        setAssignedContentIds: (state, action) => {
            if (!action.payload || action.payload.length === 0) {
                return;
            }
            state.selectedContentIds = action.payload;
        },
        clearSelectedContentIds: state => {
            state.selectedContentIds = [];
        },
        toggleContentAssignmentSnakbar: (state, action) => {
            state.contentAssignmentSnakbar = {
                open: action.payload?.open || false,
                title: action.payload?.title || 'Success', // Default to 'Success'
                message: action.payload?.message || '',
                severity: action.payload?.severity || 'success', // Default to 'success'
            };
        },
    },
    extraReducers: builder => {
        builder.addMatcher(
            contentAssignmentApi.endpoints.getContentAssignedToRole.matchFulfilled,
            (state, { payload }) => {
                const selectedContentIds = payload?.map(content => content.id) || [];
                state.selectedContentIds = selectedContentIds;
            }
        );
    },
});

// Export the actions generated from the slice
export const {
    resetContentAssignmentState,
    setActiveRole,
    setSelectedDomainAndCategory,
    setAssignedContentIds,
    clearSelectedContentIds,
    toggleContentAssignmentSnakbar,
} = contentAssignmentSlice.actions;

export const { actions, reducer } = contentAssignmentSlice;
export default reducer;
